module.exports = __webpack_public_path__ + "static/media/person3.81ca9217.svg";